import axios from "axios";
import baseUrl from "./baseUrl";
import UpdateDeviceDto, { CreateDeviceDto, Device } from "../models/Device";
import { FilterQuery } from "mongoose";

export default class DeviceApi {
	static resourceUrl = baseUrl + "/device-management";

	static async createDevice(data: {
		token: string | null;
		device: CreateDeviceDto;
	}): Promise<any> {
		// Send a POST request
		const response = await axios({
			method: "POST",
			url: this.resourceUrl + "/create",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + data.token,
			},
			data: data.device,
		});

		return response.data;
	}

	static async triggerDeviceAnalysis(data: {
		id: string;
		accessToken: string;
	}): Promise<any> {
		// Send a POST request
		const response = await axios({
			method: "POST",
			url: this.resourceUrl + "/trigger-device-analysis",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + data.accessToken,
			},
			data: { id: data.id },
		});

		return response.data;
	}

	static async listDevices(data: {
		token: string | null;
		query: FilterQuery<Device>;
	}): Promise<any> {
		// Send a POST request
		const response = await axios({
			method: "GET",
			url: this.resourceUrl + "/list?q=" + JSON.stringify(data.query),
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + data.token,
			},
		});

		return response.data;
	}

	static async listDeviceStatuses(data: {
		token: string | null;
	}): Promise<any> {
		// Send a POST request
		const response = await axios({
			method: "GET",
			url: this.resourceUrl + "/list-device-statuses",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + data.token,
			},
		});

		return response.data;
	}

	static async getDevice(data: {
		deviceId: string | undefined;
		token: string | null;
	}): Promise<any> {
		const { deviceId, token } = data;

		// Send a POST request
		const response = await axios({
			method: "GET",
			url: this.resourceUrl + "/" + deviceId,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
		});

		return response.data;
	}

	static async getOneDevice(data: {
		token: string | null;
		query: {};
		includeExceptions: boolean;
	}) {
		const { token, query, includeExceptions } = data;

		// Send a POST request
		const response = await axios({
			method: "GET",
			url:
				this.resourceUrl +
				"/get-one?q=" +
				JSON.stringify(query) +
				"&includeExceptions=" +
				includeExceptions,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
		});

		return response.data;
	}

	//Delete device
	static async deleteDevice(data: {
		token: string | null;
		deviceId: string | undefined;
	}): Promise<any> {
		const { deviceId, token } = data;

		// Send a POST request
		const response = await axios({
			method: "DELETE",
			url: this.resourceUrl + "/" + deviceId,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
		});

		return response.data;
	}

	//PUT device updateDevice method
	static async updateDevice(data: {
		token: string | null;
		dto: UpdateDeviceDto;
	}): Promise<any> {
		// Send a POST request
		const { dto, token } = data;
		const response = await axios({
			method: "PUT",
			url: this.resourceUrl + "/" + dto.id,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
				Authorization: "Bearer " + token,
			},
			data: dto,
		});

		return response.data;
	}
}
